// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `



.mimetika-chart {
    /*max-height: 55vh;*/
    position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/css/chart.css"],"names":[],"mappings":";;;;AAIA;IACI,oBAAoB;IACpB,kBAAkB;AACtB","sourcesContent":["\n\n\n\n.mimetika-chart {\n    /*max-height: 55vh;*/\n    position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
